function instruments () {
    function instrument() {}
    instrument.get_utc_difference = function () {
        var date = new Date;
        var utc_date = new Date( date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), 
                        date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds() );
        return Math.floor((date.getTime() - utc_date.getTime())/1000)
    }

    return instrument
}

export default instruments



// WEBPACK FOOTER //
// ./src/assets/js/instruments.js